import { render, staticRenderFns } from "./CreateReelOrder.vue?vue&type=template&id=0137c366&scoped=true&"
import script from "./CreateReelOrder.vue?vue&type=script&lang=js&"
export * from "./CreateReelOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateReelOrder.vue?vue&type=style&index=0&id=0137c366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0137c366",
  null
  
)

export default component.exports